<template>
  <div>
    <list
      row-key="Id"
      ref="list"
      unit="考勤明细"
      :page="page"
      :query-params="params"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="学期">
          <el-select v-model="params.TermId" size="mini" @change="setSection">
            <template v-for="(i,index) in terms">
              <el-option :key="index" :value="i.TermId" :label="i.TermName"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="日期">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 250px;"
            value-format="yyyy-MM-dd"
            unlink-panels
            :editable="false"
            :clearable="false"
          ></el-date-picker>
          <!-- <el-date-picker
            size="mini"
            :clearable="false"
            v-model="params.AttendanceDate"
            value-format="yyyy-MM-dd"
          />-->
        </el-form-item>
        <el-form-item label="节次">
          <el-select v-model="params.SectionNumber" size="mini" clearable>
            <template v-for="(i,index) in sections">
              <el-option :key="index" :value="i.SectionId" :label="i.SectionName"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="班级">
          <select-input
            placeholder="请选择班级"
            :label="params.ClassName"
            v-model="params.ClassId"
            @click="openClass"
          />
        </el-form-item>
        <el-form-item label="学生姓名">
          <el-input size="mini" v-model="params.FullName" placeholder="请输入学生姓名" clearable />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column label="日期" :min-width="isMB?100:''">
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.AttendanceDate)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="StudentNumber" label="班级" :min-width="isMB?85:''">
          <template slot-scope="{row}">
            <span>{{row.Grade}}{{row.Class}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="FullName" label="姓名" />
        <el-table-column prop="SectionName" label="节次" />
        <el-table-column prop="RollCallTeacherName" label="点名教师" />
        <el-table-column prop="Reason" label="缺勤原因" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <class-dialog ref="classDialog" selectable @select="setClass" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import classDialog from "@/components/ed/class/listDialog";

export default {
  mixins: [listMixin],
  components: {
    list,
    classDialog,
  },
  props: {
    showCheckbox: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    dateRange: {
      get() {
        return [this.params.StartDate, this.params.EndDate];
      },
      set(value) {
        console.log(value);
        if (value) {
          this.params.StartDate = value[0];
          this.params.EndDate = value[1];
          this.$refs.list.initParams.StartDate = value[0];
          this.$refs.list.initParams.EndDate = value[1];
        }
      },
    },
  },
  data() {
    return {
      api: require("@/api/at/attendanceDts").default,
      section_api: require("@/api/ed/section").default,
      term_api: require("@/api/ed/term").default,
      params: {
        StartDate: this.$commonJs.getToday(),
        EndDate: this.$commonJs.getToday(),
        SectionNumber: null,
        ClassId: 0,
        ClassName: "",
        FullName: "",
        TermId: 0,
      },
      // dateRange: "",
      terms: [], //学期列表
      sections: [], //课程节次列表
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    openClass() {
      this.$refs.classDialog.open().then((that) => {
        that.getData();
      });
    },
    setClass(data) {
      console.log("setClass", data);
      this.params.ClassId = data.ClassId;
      this.params.ClassName = data.ClassName;
    },
    setParams() {
      console.log("setParams");
      this.term_api.list().then((res) => {
        this.terms = res.Data;
        if (this.terms.length > 0) {
          this.params.TermId = this.terms[0].TermId;
          this.$refs.list.initQueryParams.TermId = this.params.TermId;
          this.setSection();
          this.getData(this.params);
        }
      });
      // console.log(this.params);
      // this.$refs.list.query(this.params);
    },
    setSection() {
      this.sections = [];
      for (let i = 1; i <= 10; i++) {
        this.sections.push({
          SectionId: i,
          SectionName: "第" + i + "节课",
        });
      }
      // this.section_api.list({ TermId: this.params.TermId }).then((res) => {
      //   console.log("sections", res);
      //   if (res.Data != null && res.Data.length > 0) {
      //     this.sections = res.Data;
      //     // this.params.SectionId = this.sections[0].SectionId;
      //     // this.$refs.list.initQueryParams.SectionId = this.params.SectionId;
      //   }
      // });
    },
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      var params = this.$commonJs.obj.removeNullKey(this.params);
      // console.log("params", params);
      this.api.export(params).then(() => {
        loading.close();
      });
    },
  },
};
</script>